export default __webpack_public_path__ + "static/media/hero-image-2.ac6117c7.png";